module.exports = __webpack_public_path__ + "static/img/time.4bd6fa7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/time.png
// module id = qKtB
// module chunks = 1